// extracted by mini-css-extract-plugin
export default {"tableContainer":"GridTable_tableContainer__oCYZH","tableHead":"GridTable_tableHead__TiYLT","tableBody":"GridTable_tableBody__7QdFm"};